import { render, staticRenderFns } from "./ExportDocuments.vue?vue&type=template&id=b2daf97c&"
import script from "./ExportDocuments.vue?vue&type=script&lang=js&"
export * from "./ExportDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports